export default {"src":"/_next/static/media/LLY.d128aae0.svg","height":18,"width":18};